import { useMemo } from "react";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import { useOrgConfig } from "src/hooks/useOrgConfig";

export const useIsSsoOrg = () => {
  const orgConfigRD = useOrgConfig<OrgConfig.LoginConfig>("Login");

  return useMemo(() => {
    return orgConfigRD.map(
      (data) => data?.admin.some((n) => n.method === "sso") ?? false
    );
  }, [orgConfigRD]);
};
